import Manager from './AudienceHub';

export const AudienceHub = Manager;



// WEBPACK FOOTER //
// ./src/app/views/audienceHub/index.js